import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../../Actions/Config'
import { handleRedirection, payRentCarService } from "../../Actions/CheckoutAction"
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import Helmet from '../Common/Helmet'
import { functions } from 'firebase'

const mapStateToProps = (state) => {
    return {
        checkoutReducer: state.CheckoutReducer
    }
}

const mapDispatchToProps = dispatch => ({
    handleRedirection: (bool) => dispatch(handleRedirection(bool)),
    payRentCarService: (info, data, vehicle) => dispatch(payRentCarService(info, data, vehicle))
});

function getEndDate(start, count) {

    const parts = start.split('/');

    const startDate = new Date(
        parts[2],       // year
        parts[1] - 1,   // month (0 indexed)
        parts[0]        // day
    );

    startDate.setDate(startDate.getDate() + count);

    return startDate.toLocaleDateString('en-GB');
}

class RentCarReserve extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: "",
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            nationality: "",
            message: "",
            agree_check: false,
            date: new Date().toLocaleDateString('en-GB'),
            no_of_days: null
        }
        this.props.handleRedirection(false)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        var data = this.props.checkoutReducer.data
        if (data != null) {
            const start_date = data.start_date
            const end_date = data.end_date;

            const parseDate = (dateString) => {
                const [day, month, year] = dateString.split("/");
                return new Date(year, month - 1, day);
            };

            const start = parseDate(start_date);
            const end = parseDate(end_date);

            const diffTime = end - start;
            const diffDays = diffTime / (1000 * 60 * 60 * 24);
            this.setState({
                no_of_days: diffDays
            })
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }
    handleClick = (event) => {
        this.setState({
            [event.target.name]: event.target.checked
        })
    }
    handleSubmitPay = () => {
        const { title, first_name, last_name, email, phone, nationality, message, agree_check } = this.state

        if (title != "" && first_name != "" && last_name != "" && email != "" && phone != "" && nationality != "" && agree_check) {
            this.props.payRentCarService(
                { title, first_name, last_name, email, phone, nationality, message }, this.props.checkoutReducer.data, this.props.checkoutReducer.tour)
        }

    }

    render() {
        const { data, tour: vehicle } = this.props.checkoutReducer;
        console.log(vehicle, "Sajith Data")
        return <Fragment>
            <Header Home={false} />

            <div id="main-container">
                <div className="row">
                    <div className="col-md-8 col-md-offset-2" style={{ margin: "85px auto 20px" }}>
                        <h2 className="orc-h2"> Review Your Order & Checkout </h2>

                        <div className="rso-min ">
                            <div className="hedin-pn">
                                <h4>Review Your Order</h4>
                            </div>
                            <div className='row'>

                                <div className="col-md-9">
                                    <table className="sm-table">
                                        <tbody>
                                            <tr>
                                                <td className="confirm_cell_title">Booking Date</td>
                                                <td className="confirm_cell_value"> {this.state.date} </td>
                                            </tr>
                                            <tr>
                                                <td className="confirm_cell_title">Package Name</td>
                                                <td className="confirm_cell_value">{vehicle.name}</td>
                                            </tr>
                                            <tr>
                                                <td className="confirm_cell_title">Vehicle Name</td>
                                                <td className="confirm_cell_value">{vehicle?.vehicle_type.type}</td>
                                            </tr>
                                            <tr>
                                                <td className="confirm_cell_title">Start Date</td>
                                                <td className="confirm_cell_value">{data.start_date}</td>
                                            </tr>
                                            <tr>
                                                <td className="confirm_cell_title">End Date</td>
                                                <td className="confirm_cell_value">{data.end_date}</td>
                                            </tr>
                                            <tr>
                                                <td className="confirm_cell_title">No of Days</td>
                                                <td className="confirm_cell_value">{this.state.no_of_days}</td>
                                            </tr>
                                            <tr>
                                                <td className="confirm_cell_title">Total</td>
                                                <td className="confirm_cell_value"><b>USD {data.price}</b> </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-3 or_tot_max_wid" style={{ margin: "auto" }}>
                                    <div className="cor_tol or_tot_cir">
                                        <h3>Order Total</h3>
                                        <span>USD {Number(data.price).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div class="request-a-quote" id="quote-form">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h3>Please fill the below form with your details</h3>
                            </div>
                        </div>

                        <div class="row form-raq">

                            <div class="col-lg-4 col-sm-6">
                                <div class="form-inner">

                                    <div class="form-cont">
                                        <label>Title<font color="red">*</font></label>
                                        <select class=" textbox txt-raq " name="title" id="title" value={this.state.title} onChange={this.handleChange} placeholder="select title">
                                            <option value="" disabled selected hidden>Select title</option>
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Miss">Ms</option>
                                        </select>

                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-sm-6">
                                <div class="form-inner">

                                    <div class="form-cont">
                                        <label>First Name<font color="red">*</font></label>
                                        <input type="text" name="first_name" value={this.state.first_name} onChange={this.handleChange} class="textbox txt-raq" id="fname" />

                                    </div>

                                </div>
                            </div>

                            <div class="col-lg-4 col-sm-6">
                                <div class="form-inner">

                                    <div class="form-cont">
                                        <label>Last Name<font color="red">*</font></label>
                                        <input type="text" name="last_name" value={this.state.last_name} onChange={this.handleChange} class="textbox txt-raq" id="lname" />

                                    </div>

                                </div>
                            </div>


                            <div class="col-lg-4 col-sm-6">
                                <div class="form-inner">

                                    <div class="form-cont">
                                        <label>Email<font color="red">*</font></label>
                                        <input type="text" onChange={this.handleChange} value={this.state.email} name="email" class="textbox txt-raq" id="email" />
                                        <label id="email_validation" color="red"> </label>

                                    </div>

                                </div>
                            </div>


                            <div class="col-lg-4 col-sm-6">
                                <div class="form-inner">

                                    <div class="form-cont">
                                        <label>Contact Number<font color="red">*</font></label>
                                        <input type="text" name="phone" value={this.state.phone} onChange={this.handleChange} class="textbox txt-raq" id="cnumber" />

                                    </div>

                                </div>
                            </div>

                            <div class="col-lg-4 col-sm-6">
                                <div class="form-inner">

                                    <div class="form-cont">
                                        <label>Nationality<font color="red">*</font></label>
                                        <input type="text" name="nationality" value={this.state.nationality} onChange={this.handleChange} class="textbox txt-raq" id="nationality" />
                                    </div>
                                </div>

                            </div>
                            <div class="col-lg-12 col-sm-12">
                                <div class="form-inner">
                                    <label>Message</label>
                                    <textarea name="textarea" name="message" value={this.state.message} onChange={this.handleChange} class="textarea txtarea-raq"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row button-taq-cont">
                            <div class="col-lg-6 taq-cont">
                                <span class="cc-custom"><input checked={this.state.agree_check} onClick={this.handleClick} name="agree_check" type="checkbox" /></span>
                                <span class="cc-label">I agree to the terms and conditions</span>
                            </div>
                            <div class="col-lg-6 button-cont ">
                                <button type="submit" id="form-check" onClick={this.handleSubmitPay}
                                    class="button btn-blue btn-arrow-next btn-raq pull-right disable-itinerary-submit">Proceed to
                                    Pay<span class="bi bi-chevron-right"></span></button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer hyperLink={false} />

        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(RentCarReserve);